import { useState, useEffect } from 'react';
import Axios from "axios";
import { GetJobRoles, GetJobPosts,siteURL,updateStatus,GetCountries, GetbenchSalesSubmissions,GetListOfVendorsByEmployeeID, GetListOfUsersWithAdminByEmployeeID, UpdateBenchsalesSubmissionStatus } from '../../apiconstants/constants.js';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../../helpers/loadingspinner.js';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from '../../commonlayouts/consultantlayout.js';
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../../contexts/countrycodecontext.js';
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewBenchSalesReports = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'  
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [jobRoles, setJobRoles] = useState([]);
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showModal,setShowModal] = useState(false)
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [candidateId, setCandidateId] = useState(null);
  const [hasNoData, setHasNoData] = useState(false);
  const { selectedCountry} = useCountry();
  const [vendorData, setVendorData] = useState([]);
  const [selectedSubmissionID, setSelectedSubmissionID] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showDropdownModal, setShowDropdownModal] = useState(false);
  const [comments, setComments] = useState(""); // End date state
  const [submittedDate, setSubmittedDate] = useState();
  const [jobPosts, setJobPosts] = useState([]);
  const [selectedCandidateGuids, setSelectedCandidateGuids] = useState([]); // now only storing GUID strings
  const guid = localStorage.getItem("guid");
  const token = localStorage.getItem("jwtToken");
    console.log("guid",guid)
const [usersList, setUsersList] = useState([]);
console.log("usersList",usersList)
const [originalCandidateData, setOriginalCandidateData] = useState([]);
const [selectedTile, setSelectedTile] = useState("reset");
const [baseFilteredData, setBaseFilteredData] = useState([]); 
const [summaryData, setSummaryData] = useState({});
const [selectedDateFilter, setSelectedDateFilter] = useState("This month");
const [filtersLoaded, setFiltersLoaded] = useState(false);

const dateFilterOptions = [
  { value: "Past 7 days", label: "Past 7 days" },
  { value: "Past 30 days", label: "Past 30 days" },
  { value: "This month", label: "This month" },
  { value: "Past 6 months", label: "Past 6 months" },
  { value: "Past 1 year", label: "Past 1 year" },
  { value: "Past 2 years", label: "Past 2 years" },
  { value: "Past 3 years", label: "Past 3 years" },
];
const [selectedUserGuid, setSelectedUserGuid] = useState(null);
const [showEmailTypeModal, setShowEmailTypeModal] = useState(false);
const [selectedEmailType, setSelectedEmailType] = useState("followup");

const fetchJobPosts = async (JobRoleID, vendorGuid) => {
      setIsLoading(true);

      try {
        const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filter based on selected Job Role and Vendor (client)
        const filteredPosts = response.data.filter((x)=>x.status =='Active')
            console.log(filteredPosts)
    
        setJobPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching job posts", error);
      } finally {
        setIsLoading(false);
      }
    };
    console.log("46",selectedCountry)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
const fileName = "CandidatesList"; 
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
let Guid="";

// const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")

const roleID = localStorage.getItem("roleID")
const appliedfilter = localStorage.getItem("candidatereportFilters")
if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
  const [selectAll, setSelectAll] = useState(false);

  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [workmodeOptions] = useState([
    { value: "", label: "Select Work Mode" },
    { value: "1", label: "Work from Home" },
    { value: "2", label: "Work from Office" },
    { value: "3", label: "Hybrid" },
  ]);
   const [candidateType,setCandidateType] = useState([
        {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
        {candidateTypeID:"C2C",typeName:"C2C"},
        {candidateTypeID:"W2",typeName:"W2"},
      {candidateTypeID:"1099",typeName:"1099"}]);
  const [selectedWorkMode, setSelectedWorkMode] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountryfilter, setSelectedCountry] = useState(null);
  
const { register, handleSubmit, formState: { errors, isSubmitting }, control, reset } = useForm();
  
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined"||value === "null..." || value === "undefined...") 
    ? "" 
    : value;
 
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "", 
    // clientStatus: "",   
    JobRoleID: "",
    SubmittedDate: null,  
    VendorGuid:"",
    CandidateType: "",
    ClientStatus: null,
  });

const handleConfirmEmailType = () => {
  const selectedCandidate = candidateData.find(
    (c) => c.submissionID === selectedCandidateGuids[0]
  );

  if (!selectedCandidate) return;

  const {
    candidateName,
    email: candidateEmail,
    jobRoleName,
    staffingContactEmail,
    staffingContactName,
    staffingContactCompanyName,
  } = selectedCandidate;

  // Determine which email and name to use
  const emailToSend =
    selectedEmailType === "followup"
      ? staffingContactEmail
      : candidateEmail;

  const nameToSend =
    selectedEmailType === "followup"
      ? staffingContactName
      : candidateName;

  navigate("/Employer/SendFollowUpEmail", {
    state: {
      emailToSend,
      nameToSend,
      candidateName,
      candidateEmail,
      staffingContactName,
      staffingContactEmail,
      staffingContactCompanyName,
      jobRoleName,
      emailType: selectedEmailType, // optional — helps you handle in next screen
    },
  });

  setShowEmailTypeModal(false);
};


    const handleModalOpen = (guid,comments,clientStatus,submittedDate) => {
      console.log("123: comments :",comments, clientStatus,guid)
     
    setSelectedSubmissionID(guid);
    setComments(comments);
    setSelectedStatus(clientStatus);
     setSubmittedDate(submittedDate);
    setShowDropdownModal(true);
  };

  const handleModalClose = () => {
    setShowDropdownModal(false);
  };
const handleCandidateCheckbox = (guid) => {
  setSelectedCandidateGuids(prev => {
    if (prev.includes(guid)) {
      // Deselect if already selected
      return [];
    } else {
      // Select new candidate (single selection)
      return [guid];
    }
  });
};

const isFilterApplied = Boolean(localStorage.getItem("candidatereportFilters"));

useEffect(() => {
  const initializeData = async () => {
    try {
      setIsLoading(true);

      const savedFilters = JSON.parse(localStorage.getItem("candidatereportFilters"));

      // Always load static data first
      await Promise.all([
        fetchJobRoles(),
        fetchCountries(),
        GetVendorsList(),
        fetchJobPosts(),
        GetUsersList(),
      ]);

      if (savedFilters) {
        console.log("✅ Restoring saved filters:", savedFilters);
        setFilters(savedFilters);
        setSelectedDateFilter(savedFilters.SubmittedDate || "This month");
        // setSelectedUserGuid(savedFilters.UserGuid || guid);
        await GetCandidateList(savedFilters.SubmittedDate, savedFilters.UserGuid);
      } else {
        console.log("➡️ No saved filters, loading default data");
        await GetCandidateList(selectedDateFilter, selectedUserGuid || guid);
      }

      setFiltersLoaded(true);
    } catch (error) {
      console.error("Error initializing page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  initializeData();
}, [selectedCountry]);


const GetVendorsList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

  Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};
const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
    console.error("Error fetching job roles", error);
  }
};
const fetchCountries = async () => {
  try {
    const response = await fetch(GetCountries.APIURL,
      { headers: {    Authorization: `Bearer ${token}`,
    }}
    );
    const json = await response.json();
    
    // Format the countries for react-select
    const countryOptions = json.map((country) => ({
      value: country.countryID, // Assuming each country has a unique ID
      label: country.country, // Adjust based on API response structure
    }));

    setCountries([{ value: "", label: "Select Country" }, ...countryOptions]);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};


const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole
}));
 const handleVendorChange = (event) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        VendorGuid: event.target.value, // ✅ Store as a string
      }));
    };
const handleConfirmDeactivation = async () => {

   const params = {
      userGuid: Guid
    };

     await Axios.put(`${updateStatus.APIURL}?Guid=${candidateId}&isActive=${false}`, params,
      { headers: { Authorization: `Bearer ${token}` } }
     )
      .then((result) => 
        {
          if(result.data=='Submission status updated successfully.'){
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'DeActivated succesfully',
              showConfirmButton: false,
              timer: 2000,
            })
          }
          setCandidateData(prevData => prevData.filter(candidate => candidate.submissionID !== candidateId));

        setIsLoading(false);
        setShowModal(false);

      })
      .catch((error) => {
        console.log("Error" + error);
      });
    }



const handleCancel = () => {
  setShowModal(false);
};

const handleCancelSearch = () => {
  setShowFilterModal(false);
};

 const GetUsersList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;

  Axios.get(GetapiUrl,
    { headers: { Authorization: `Bearer ${token}` } }
  )
    .then((result) => {
      setIsLoading(false);

      if (Array.isArray(result.data)) {
      const filteredUsers = result.data.filter(
          (user) =>
            (user.usertype === "Bench Sales" || user.roleID === 2) &&
            user.countryMappings?.includes(selectedCountry)
        );
        setUsersList(filteredUsers);

        // ✅ Pick the default GUID dynamically
        const defaultUser = filteredUsers.find((u) => u.guid === Guid) || filteredUsers[0];

        // if (defaultUser) {
        //   setSelectedUserGuid(defaultUser.guid);
        //   console.log("✅ Default User:", defaultUser.firstName, defaultUser.guid);

        //   // Optional: auto-load their candidate list
        //   // GetCandidateList(selectedDateFilter, defaultUser.guid);
        // }
      } else {
        setUsersList([]);
      }
    })
    .catch((error) => {
      console.error("Error fetching users:", error);
    });
};



const tileConfig = [
  { title: "Total Candidates", key: "overallCount", bg: "bg-primary", type: "reset" },
  { title: "New", key: "newCount", bg: "bg-secondary", status: "New" },
  { title: "Submitted", key: "submittedCount", bg: "bg-primary", status: "Submitted" },
  { title: "In-Progress", key: "inProgressCount", bg: "bg-warning", status: "In-Progress" },
  { title: "Selected", key: "selectedCount", bg: "bg-success", status: "Selected" },
  { title: "Interviews Scheduled", key: "interviewScheduledCount", bg: "bg-info", status: "Interview Scheduled" },
  { title: "Rejected", key: "rejectedCount", bg: "bg-danger", status: "Rejected" },
  { title: "On Hold", key: "onHoldCount", bg: "bg-dark", status: "On Hold" },
];


const GetCandidateList = async ( dateFilter = selectedDateFilter,  userGuid
) => {
  const finalUserGuid =  selectedUserGuid || userGuid  || guid;
  setIsLoading(true);
  try {
     const savedFilters = JSON.parse(localStorage.getItem("candidatereportFilters"));
    const isFilterApplied =
      savedFilters &&
      Object.values(savedFilters).some(
        (v) => v !== "" && v !== null && !(Array.isArray(v) && v.length === 0)
      );

    // ✅ Build the correct API URL
    let apiUrl = "";
    if (isFilterApplied) {
      // Use your filtered API
      apiUrl = `${GetbenchSalesSubmissions.APIURL}?benchSalesGuid=${finalUserGuid}&dateFilter=${encodeURIComponent(dateFilter )}&Usertype=Benchsales`;
     
    }
    else {
      // Use default API when no filters applied
      apiUrl = `${GetbenchSalesSubmissions.APIURL}`;
    }
      const response = await Axios.get(apiUrl,
      { headers: { Authorization: `Bearer ${token}` } }
      );

    const { summary, submissions } = response.data;

       setSummaryData({
      overallCount: summary?.overallCount || 0,
      newCount: summary?.newCount || 0,
      submittedCount: summary?.submittedCount || 0,
      inProgressCount: summary?.inProgressCount || 0,
      interviewScheduledCount: summary?.interviewScheduledCount || 0,
      onHoldCount: summary?.onHoldCount || 0,
      selectedCount: summary?.selectedCount || 0,
      rejectedCount: summary?.rejectedCount || 0,
    });
    // Save candidates
    setCandidateData(submissions || []);
    setOriginalCandidateData(submissions || []);
    setBaseFilteredData(submissions || []);

    setHasNoData((submissions || []).length === 0);
  } catch (error) {
    console.error("Error fetching candidate list:", error);
    setCandidateData([]);
    setOriginalCandidateData([]);
    setBaseFilteredData([]);
    setSummaryData({
      totalCandidates: 0,
      new: 0,
      jobSubmission: 0,
      shortlisted: 0,
      offersReleased: 0,
      interviewsScheduled: 0,
      rejected: 0,
      onHold: 0,
    });
    setHasNoData(true);
  } finally {
    setIsLoading(false);
  }
};
const handleSendFollowUp = () => {
  if (selectedCandidateGuids.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Candidate Selected",
      text: "Please select at least one candidate to send an email.",
    });
    return;
  }

  // Just open the modal first
  setShowEmailTypeModal(true);
};  
const handleFilterSearch=()=>{
    setShowFilterModal(true);
}
const handleJobRoleChange = (selectedOptions) => {
  const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", "); 
  setFilters((prevFilters) => ({
    ...prevFilters,
    JobRoleID: jobRolesLabels, // ✅ Store as a string
  }));
};

  const handleStatusChange = () => {
  if(selectedStatus == null){
    Swal.fire("You can not submit without selecting any option!")
    return
  }
  setIsLoading(true)
  const payload ={
"id": selectedSubmissionID,
"status": selectedStatus,
"comments": comments
  }
  Axios.put(`${UpdateBenchsalesSubmissionStatus.APIURL}`,payload,
    { headers: { Authorization: `Bearer ${token}` } }
  )
    .then((result) => {
      setIsLoading(false)
      if (result.data.message == 'Submission status updated successfully.') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Updated Successfully ',
          showConfirmButton: false,
          timer: 5000
        })
        GetCandidateList();
        setShowDropdownModal(false);
      }
    }
    )
};
    
   const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));
const handleTileClick = (tileStatus) => {
  setSelectedTile(tileStatus);
  sessionStorage.setItem("candidateTile", tileStatus);

  if (tileStatus === "reset") {
    setCandidateData(baseFilteredData);
  } else {
    const filtered = baseFilteredData.filter(
      (candidate) =>
        candidate.status?.toLowerCase() === tileStatus.toLowerCase()
    );
    setCandidateData(filtered);
  }
};
    const userTypeOptions = [
  { value: "Recruiter", label: "Recruiter" },
  { value: "Bench Sales", label: "Bench Sales" },
];
  useEffect(() => {
  const filteredData = candidateData?.filter(candidate => {
    const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();

    // If no search term
    if (!lowerSearchTerm) {
        return true; 
    }

    // Determine search logic based on operators
    let searchTerms;
    let isAndSearch = false;
  
    if (lowerSearchTerm?.includes(' + ') || lowerSearchTerm?.includes(' and ')) {
        searchTerms = lowerSearchTerm?.split(/\s*\+\s*|\s+and\s+/);
        isAndSearch = true; // ALL terms must match
    } else if (lowerSearchTerm.includes(' or ')) {
        searchTerms = lowerSearchTerm?.split(/\s+or\s+/);
        isAndSearch = false; // At least one term must match
    } else {
        searchTerms = [lowerSearchTerm]; // Treat it as a single phrase
        isAndSearch = false;
    }
  
    // Convert search terms to lowercase and trim spaces
    searchTerms = searchTerms.map(term => term.trim());
  
    // Function to check if a field contains the *entire search term*
    const fieldMatchesTerm = (term) => {
        return [
            candidate.fullName,
            candidate.technicalSkill,
            candidate.jobRoleName,
            candidate.preferLocation,
            candidate.address,
            candidate.profileSummary,
            candidate.workAuthorizationandValidity,
            candidate.email
        ].some(field => field?.toLowerCase()?.includes(term)) ||
        (candidate.experience !== undefined && 
         (candidate.experience?.toString()?.includes(term) || `${candidate.experience} years`?.includes(term)));
    };
  
    // Apply AND / OR search logic
    const matchesSearch = isAndSearch
        ? searchTerms.every(fieldMatchesTerm) // Require all terms to match (AND search)
        : searchTerms.some(fieldMatchesTerm); // At least one term matches (OR search)

    return matchesSearch;
  });
  if (filteredData.length === 0) {
    setHasNoData(true);
    setData([]); // clear the UI
    setPageCount(0);
    return;
  } else {
    setHasNoData(false);
  }
  const getExperienceText = (experience) => {
    if (!experience) return '';
    return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
  };
    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType =='grid' ? slice.map((data) => {
                   const isSelected = selectedCandidateGuids.includes(String(data.guid));

      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
            <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 600, height: 600, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 100 }}>
                  <div className='row'>
                    <div className='col-4'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                        <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                        {/* <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} /> */}

                      </OverlayTrigger>
                    </div>
                    <div className='col-8'>
              
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.candidateName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:250}}>

                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>               
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{ selectedCountry == 2 ? "Bill Rate" : "Expected CTC" }</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-dollar-sign" aria-hidden="true"></i>{safeValue(data.payrate)}</p>
                </OverlayTrigger>
                  {data.vendorName!==null && data.vendorName!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Name - Company Name</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {safeValue(data.staffingContactName)}  - {safeValue(data.staffingContactCompanyName)} </p>
                  </OverlayTrigger>)}
       <div className="d-flex align-items-center">       
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Status</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i>{safeValue(data.status)}</p>
                </OverlayTrigger>
                 <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Status</Tooltip>}>
                                                    <FontAwesomeIcon icon="fas fa-edit" onClick={() => handleModalOpen(data.submissionID,data.comments,data.status,data.submittionDate)} style={{ marginLeft: 10, marginTop: -14, color: "#00a7ac", fontSize: 14 }} />
                                                  </OverlayTrigger>
                                              
                                                 
</div>    
 <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Submission Type
            </Tooltip>
          )}
        >
          <p style={{ fontSize: 14 }}>
            <i
              style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
              className="fas fa-calendar-alt"
              aria-hidden="true"
            ></i>
             {
    (data.submittionType)
  }
          </p>
        </OverlayTrigger>  
  <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Submitted Date
            </Tooltip>
          )}
        >
          <p style={{ fontSize: 14 }}>
            <i
              style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
              className="fas fa-calendar-alt"
              aria-hidden="true"
            ></i>
             {
    (data.submittionDate ? new Date(data.submittionDate).toLocaleDateString("en-GB") : "")
  }
          </p>
        </OverlayTrigger>  
 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> <span
        dangerouslySetInnerHTML={{
          __html: safeValue(data.comments)
        }}
      /></Tooltip>)}>
                     <p className="text-para" style={{color:"black", ver: "middle" }}>
      <i className="fa fa-building icons"></i>
      <span
              dangerouslySetInnerHTML={{
          __html: safeValue(data.comments)
        }}
      />
    </p>
                  </OverlayTrigger>
                </div>
              <div className={`card-footer d-flex justify-content-center align-items-center gap-3`} style={{ background: "none" }}>

  <Link to={`/Employer/ReportViewCandidateDetailsByCandidateGUid?submissionID=${data.candidateguid}`}>
    <OverlayTrigger placement="bottom" overlay={<Tooltip>View</Tooltip>}>
      <button style={{ background: "none", border: "none" }}>
        <i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
      </button>
    </OverlayTrigger>
  </Link>
<input
  type="checkbox"
  checked={selectedCandidateGuids.includes(String(data.submissionID))}
  onChange={() => handleCandidateCheckbox(String(data.submissionID))}
  title="Select for follow-up email"
  style={{ cursor: "pointer", width: 16, height: 16 }}
/>


</div>

                
              </div>
        </div>
      )  })
      :
    
      <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                            <table
  className="table"
  style={{
 //   minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
 


  }}
>
  <thead>
       <tr>
      <th style={{ padding: "4px" }}>Candidate Name</th>
      <th style={{ padding: "4px" }}>Job Role</th>
      <th style={{ padding: "4px" }}>Email</th>
     { selectedCountry == 2 ?<th style={{ padding: "4px" }}>Bill Rate</th>: <th style={{ padding: "4px" }}> Expected CTC</th>}
      <th style={{ padding: "4px" }}>Staffing Contact - Company Name</th>
    
      <th style={{ padding: "4px" }}>Status</th>
      <th style={{ padding: "4px" }}>Submission Type</th>
      <th style={{ padding: "4px" }}>Submitted Date</th>
      <th style={{ padding: "4px" }}>Comments</th>
      <th style={{ padding: "4px", width: 100 }}>Actions</th>
    </tr>
  </thead>
<tbody>
    {slice?.map((data, index) => (
      <tr key={index} style={{ marginBottom: "2px" }}>
        <td style={{ padding: "4px" }}>{safeValue(data.candidateName)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.jobRoleName)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.email)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.payrate)}</td>
        <td style={{ padding: "4px" }}>
          {safeValue(data.staffingContactName)} 
          {data.staffingContactCompanyName ? " - " + safeValue(data.staffingContactCompanyName) : ""}
        </td>
  <td style={{ padding: "4px", maxWidth: "100px", wordBreak: "break-word" }}>
  <div className="d-flex align-items-center">
    {safeValue(data.status)}
    <FontAwesomeIcon
      icon="fas fa-edit"
      onClick={() =>
        handleModalOpen(
          data.submissionID,
          data.comments,
          data.status,
          data.submittionDate
        )
      }
      style={{ marginLeft: 8, color: "#00a7ac", cursor: "pointer" }}
    />
  </div>
</td>
   
        <td style={{ padding: "4px" }}>{safeValue(data.submittionType)}</td>


        <td style={{ padding: "4px" }}>
          
            {data.submittionDate
              ? new Date(data.submittionDate).toLocaleDateString("en-GB")
              : ""}
        </td>
    {/* Comments with tooltip */}
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              <span dangerouslySetInnerHTML={{ __html: safeValue(data.comments) }} />
            </Tooltip>
          )}
        >
           <td style={{ padding: "4px", color: "black", verticalAlign: "middle" }}>
    <span
      style={{
        display: "inline-block",
        maxWidth: "180px",          // ✅ prevent overflowing
        whiteSpace: "nowrap",       // ✅ keep on single line
        overflow: "hidden",         // ✅ hide overflow
        textOverflow: "ellipsis",   // ✅ show "..."
      }}
      dangerouslySetInnerHTML={{
        __html: safeValue(data.comments)
      }}
    />
  </td>
        </OverlayTrigger>
        {/* Actions */}
       <td style={{ padding: "4px" }}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
   

    <Link to={`/Employer/ReportViewCandidateDetailsByCandidateGUid?submissionID=${data.candidateguid}`}>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>View</Tooltip>}>
        <button style={{ background: "none", border: "none", padding: "4px" }}>
          <i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
        </button>
      </OverlayTrigger>
    </Link>
 <input
  type="checkbox"
  checked={selectedCandidateGuids.includes(String(data.submissionID))}
  onChange={() => handleCandidateCheckbox(String(data.submissionID))}
  title="Select for follow-up email"
  style={{ cursor: "pointer", width: 16, height: 16 }}
/>

  </div>
</td>

      </tr>
    ))}
  </tbody>
</table>

                            </div>
      
  

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm,startDate,endDate,candidateData, perPage,viewType,selectedCandidateGuids]);
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };
  const handleClick = () => {
    const finalURL = `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`;
    navigator.clipboard.writeText(finalURL)
      .then(() => Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Copied',
        showConfirmButton: false,
        timer: 1000,
      }))
      
      
      .catch(err => console.error('Failed to copy URL: ', err));
  };
 const handleRefresh = () => {
  // Reset core data states
  setCandidateData(baseFilteredData);
  setSearchTerm("");
  setSelectedTile("reset");
setSelectedUserGuid(null);

  // Reset all filters to default
  setFilters({
    UserGuid: Guid,
    FullName: "",
    Email: "",
    ClientStatus: null,
    JobRoleID: "",
    SubmittedDate: null,
    VendorGuid: null,
    CandidateType: "",
    jobTitleID: null,
    Usertype: null,
  });

  // Reset react-hook-form fields
  reset({
    vendorCompanyName: "",
    ClientStatus: "",
    candidateTypeID: "",
  });

  // Reset filter dropdowns and selections
  setSelectedDateFilter("This month");
  // setSelectedUserGuid(Guid);
  setShowFilterModal(false); // ✅ close the modal if open

  // Remove stored filters
  localStorage.removeItem("candidatereportFilters");

  // Fetch the default data
  GetCandidateList("This month", Guid);
};
const applyFilters = () => {
  const cleanedFilters = {
    ...filters,
    SubmittedDate:
      !filters.SubmittedDate || filters.SubmittedDate === "Select Date Filter"
        ? selectedDateFilter || "This month"
        : filters.SubmittedDate,
    CountryID: selectedCountry,
    UserGuid: selectedUserGuid,
  };

  // Clean up empty values
  const filteredData = Object.fromEntries(
    Object.entries(cleanedFilters).filter(
      ([, value]) =>
        value !== "" &&
        value !== null &&
        !(Array.isArray(value) && value.length === 0)
    )
  );

  // ✅ Save filters to localStorage
  localStorage.setItem("candidatereportFilters", JSON.stringify(cleanedFilters));

  // Fetch filtered data
  GetCandidateList(cleanedFilters.SubmittedDate, cleanedFilters.UserGuid);

  // Close modal
  setShowFilterModal(false);
};
  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
             <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
    {/* <Link to="/Employer/InternalBench">
      <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
    </Link> */}
    <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}> Bench Sales Reports</h2>
    </div>
<div className="d-flex justify-content-between align-items-center mb-3">



    <div className="d-flex align-items-center  mr-3">
         <OverlayTrigger placement="bottom" overlay={<Tooltip>Bench Sales Statistics</Tooltip>}>
  <button
    className="btn btn-primary mr-3"
    onClick={() => navigate("/Employer/BenchSalesStat")}  // 👈 navigate to new screen
    style={{ backgroundColor: "#00a7ac" }}
  >
<i className="fas fa-chart-bar" style={{ color: '#fff', cursor: 'pointer' }}></i>
  </button>
</OverlayTrigger> 

<OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Outreach Benchsales List</Tooltip>)}>
                <Link to="/Employer/OverallInternalBenchOutreachCandidates">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fas fa-tachometer-alt"></i></button>
                </Link>
</OverlayTrigger>
  </div>
              <div>  

            {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
              )}
              {showIcon === 'list' && (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                  <button
                    className="btn btn-primary mr-3"
                    onClick={() => handleViewToggle('grid')}
                    style={{ backgroundColor: "#00a7ac" }}
                  >
                    <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                  </button>
                </OverlayTrigger>
              )}
           </div>
         
  </div>

        </div>
        <div>
 
        <div className="row d-flex justify-content-between">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role or Country or Address</Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technical Skill or Email or Role or Address"
        className="form-control mt-3"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>
   <div className="col-auto align-self-end">
     
      <Link>
     <OverlayTrigger placement="bottom" overlay={
  <Tooltip id="tooltip">{ isFilterApplied ? "Filter Applied" : "Apply Filter" }</Tooltip>
}>
  <button
    className="btn btn-primary mt-3 mr-3"
    onClick={handleFilterSearch}
    style={{height:50}}
    type="button"
  >
    <i className="fas fa-filter"></i> { isFilterApplied ? "Filter Applied" : "Apply Filter" }
  </button>
</OverlayTrigger>

      </Link>
      <Link>
      <OverlayTrigger placement="bottom" overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Reset</Tooltip>
      )}>
      <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
        <i className="fas fa-sync"></i> Reset Filter
      </button>
      </OverlayTrigger>
      </Link>
     
    </div>
</div>
<div className="d-flex justify-content-between flex-nowrap overflow-auto gap-3 mt-2 mb-3">
  {tileConfig.map((tile, index) => (
    <div key={index} style={{ flex: "0 0 11%", minWidth: 100, marginBottom: 12 }}>
      <div
        className={`card text-white ${tile.bg} shadow`}
        style={{
          cursor: "pointer",
          height: 65,
          borderRadius: 12,
          padding: "4px 6px",
          minWidth: 100,
          border: selectedTile === tile.status || (tile.type === "reset" && selectedTile === "reset")
            ? "2px solid black"
            : "none",
        }}
        onClick={() => {
          if (tile.type === "reset") {
            setCandidateData(baseFilteredData);
            setSelectedTile("reset");
          } else {
            handleTileClick(tile.status);
          }
        }}
      >
        <div className="card-body p-2 d-flex flex-column justify-content-center align-items-center">
          <h6 className="card-title mb-1 text-center" style={{ fontSize: "14px" }}>
            {tile.title}
          </h6>
          <p className="card-text mb-0" style={{ fontSize: "10px", fontWeight: "bold" }}>
            {summaryData[tile.key] ?? 0}
          </p>
        </div>
      </div>
    </div>
  ))}
</div>







              </div>

        <hr />
           <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

          {selectedCandidateGuids.length > 0 && (
  <button className="btn btn-primary" onClick={handleSendFollowUp}style={{ height: 45,backgroundColor: "#00a7ac" }}>
     
    Send Email {selectedCandidateGuids.length} <i className="fas fa-arrow-right" style={{ marginLeft: 5 }}></i>
  </button>
)}    
</div>
    {(!filtersLoaded || isLoading) ? (
  <center><LoadingSpinner /></center>
) : (
  <>
    {hasNoData ? (
      <div className="pb-5 text-center">
        <img
          title="No Data"
          className="no-data-img"
          alt="no-data-img"
          src={nodataimg}
          style={{ height: 370 }}
        />
      </div>
    ) : (
      <div className="row mt-5 pb-3">
        {data}
      </div>
    )}
  </>
)}

        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

<Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this candidate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
       <Modal show={showDropdownModal} onHide={handleModalClose} centered   dialogClassName="custom-inline-width">
                <Modal.Header closeButton>
                  <Modal.Title style={{fontSize:20}}>Update Candidate Status</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{width:700}}>
                  {["New","Submitted","In-Progress", "Interview Scheduled","On Hold","Selected","Rejected" ].map((status) => (
                    <Button
                    key={status}
                     size="sm"
                     variant={selectedStatus === status ? "primary" : "outline-primary"} 
                    className="w-100 mb-2"
                    onClick={() => setSelectedStatus(status)}
                  >
                    {status}
                  </Button>
                  
                  ))}
        
             <div style={{ marginBottom: 20 }}>
   {<div
    style={{
      background: "#f9f9f9",
      padding: "6px 10px",
      border: "1px solid #ddd",
      borderBottom: "none",
      borderRadius: "6px 6px 0 0",
      fontSize: 14,
      color: "#555"
    }}
  >
    <i
      style={{ fontSize: 14, color: "#00a7ac", marginRight: 8 }}
      className="fas fa-calendar-alt"
    ></i><b>Submitted Date : 
     {submittedDate ? new Date(submittedDate).toLocaleDateString("en-GB") : ""}</b>
  </div>
}
        

  <ReactQuill
    value={comments}
    onChange={setComments}
    placeholder="Comments"
    style={{ height: 180 }}
  />
</div>

                    
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => {
    console.log("Clicked Submit");
    handleStatusChange();
  }}>
                    Submit
                  </Button>
                  <Button variant="secondary" onClick={handleModalClose}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>

                <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
                      <Modal.Header closeButton>
                        <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
                       </Modal.Header>
                      <Modal.Body>
                        <div className='row'>
                              <div className='col-6 '>  
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Select User</Tooltip>}>
                            <div style={{ display: "inline-block", width: "100%" }}>
                             <Select
  options={usersList?.map((user) => ({
    value: user.guid,
    label: user.firstName,
  }))}
   // ✅ Show current selection or placeholder
  value={
    selectedUserGuid
      ? usersList
          .map((u) => ({ value: u.guid, label: u.firstName }))
          .find((opt) => opt.value === selectedUserGuid)
      : null
  }

  // ✅ Handle selection
  onChange={(selectedOption) => {
    setSelectedUserGuid(selectedOption ? selectedOption.value : null);
  }}

  placeholder="Select User" 
 styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 8,
      fontSize: "12px",
      minWidth: 180,
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  }}
/>


</div>
</OverlayTrigger>
              
                                 
                              </div>
                              <div className='col-6'>
                           
                   <OverlayTrigger placement="bottom" overlay={<Tooltip>Apply Date Filter</Tooltip>}>
    <div style={{ display: "inline-block", width: "100%" }}>
    <Select
  options={dateFilterOptions}
  placeholder="Select Date Filter"
  value={dateFilterOptions.find((option) => option.value === selectedDateFilter)}
  onChange={(option) => {
    setSelectedDateFilter(option.value); // ✅ only update state
  }}
  styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 8,
      fontSize: "12px",
      minWidth: 180,
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  }}
/>
</div>
                   </OverlayTrigger>
                         
                             
                              </div>
                        </div>
                       
                      </Modal.Body>
                     <Modal.Footer style={{ marginTop: 100 }}>
  {/* <Button variant="primary" onClick={handleRefresh}>
    <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
  </Button> */}
  <Button variant="primary" onClick={applyFilters}>
    Apply
  </Button>
  <Button variant="secondary" onClick={handleCancelSearch}>
    Cancel
  </Button>
</Modal.Footer>
                    </Modal>
              <style>
{`
  .custom-inline-width {
    max-width: 700px !important;
    width: 100%;
  }
`}
</style>
      </div>
      <Modal show={showEmailTypeModal} onHide={() => setShowEmailTypeModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Select Email Type</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="emailType"
        id="followup"
        value="followup"
        checked={selectedEmailType === "followup"}
        onChange={(e) => setSelectedEmailType(e.target.value)}
      />
      <label className="form-check-label" htmlFor="followup">
        Follow-up mail to Staffing Contact
      </label>
    </div>
    <div className="form-check mt-2">
      <input
        className="form-check-input"
        type="radio"
        name="emailType"
        id="candidate"
        value="candidate"
        checked={selectedEmailType === "candidate"}
        onChange={(e) => setSelectedEmailType(e.target.value)}
      />
      <label className="form-check-label" htmlFor="candidate">
        Intimation mail to Candidate
      </label>
    </div>
  </Modal.Body>
  <Modal.Footer>
      <Button variant="primary" onClick={handleConfirmEmailType}>
      Continue
    </Button>
    <Button variant="secondary" onClick={() => setShowEmailTypeModal(false)}>
      Cancel
    </Button>
  
  </Modal.Footer>
</Modal>
    </ConsultantLayout>
  );
}

export default ViewBenchSalesReports;


